import { Page } from '@/core/architecture'

import { StoreItemPurchaseCompleteTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreItemPurchaseComplete Page
 * Implemented as a practical sample.
 */
export const StoreItemPurchaseComplete: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreItemPurchaseCompleteTemplate state={state} {...actions} />
}
